import { useState } from "react";
import styles from "./index.module.scss";
import kesaiSrc from "../../../assets/img/kesai-scan.png"

const menuItems = [
  {
    key: "intro",
    label: "大赛介绍",
  },
  {
    key: "setup",
    label: "赛道设置",
  },
  {
    key: "participants",
    label: "参赛对象",
  },
  {
    key: "guests",
    label: "竞赛嘉宾",
  },
  {
    key: "schedule",
    label: "赛程安排",
  },
  {
    key: "prizes",
    label: "奖项设置",
  },
  {
    key: "contact",
    label: "联系我们",
  },
];

export const WebRobot = () => {
  const [active, setActive] = useState("intro");
  return (
    <div className={styles.page}>
      <div className={styles["top-bg"]}></div>
      <div className={styles["logo"]}></div>

      <div className={styles["menu"]}>
        {menuItems.map((it) => (
          <div
            id={`item-${it.key}`}
            key={it.key}
            className={`${styles["item"]} ${active === it.key ? styles["active"] : ""}`}
            onClick={() => {
              setActive(it.key)
              const anchorDom = window.document.querySelector(`#anchor-${it.key}`)
              anchorDom.scrollIntoView({
                behavior: "smooth"
              })
            }}
          >
            {it.label}
          </div>
        ))}
      </div>

      <div className={styles["title-intro"]} id="anchor-intro"></div>
      <div className={styles["text-intro"]}></div>

      <div className={styles["title-setup"]} id="anchor-setup"></div>

      <div className={styles["lane1"]}></div>
      <div className={styles["lane2"]}></div>
      <div className={styles["lane3"]}></div>
      <div className={styles["btn-entry"]}>
        <div className={styles["kesai-scan"]}>
          <img src={kesaiSrc} alt="可赛小程序码" />
        </div>
      </div>

      <div className={styles["title-participants"]} id="anchor-participants"></div>
      <div className={styles["text-participants"]}></div>

      <div className={styles["title-guests"]} id="anchor-guests"></div>
      <div className={styles["guests"]}></div>

      <div className={styles["title-schedule"]} id="anchor-schedule"></div>
      <div className={styles["schedule"]}></div>

      <div className={styles["title-prizes"]} id="anchor-prizes"></div>
      <div className={styles["text-prizes"]}>
        每个赛项产生冠军、亚军、季军各一支队伍
        <br />
        一等奖五支队伍，二等奖十支队伍，三等奖十五支队伍，所有奖金均为税前金额
      </div>
      <div className={styles["prizes"]}></div>

      <div className={styles["title-contact"]} id="anchor-contact"></div>
      <div className={styles["text-contact"]}></div>

      <div className={styles["footer"]}></div>
      <div className={styles["text-footer"]}>
        *
        本次大赛最终解释权归“全球人工智能技术创新大赛-硬件挑战赛”组织委员会所有
      </div>
    </div>
  );
};
